<template>
  <layout-default
    :hide-footer-mobile="true"
    :class="{ 'bg-red-2-light': bgColorRed }"
    :show-backpack="false"
  >
    <div class="formulario-inscribir relative">
      <div class="pdv-container">
        <div class="contenido-formulario">
          <div class="contenido-formulario-form">
            <div class="columna-form relative">
              <div class="contenido-formulario-titulo">
                <h1 v-if="selectedProgram">
                  Ingresa los datos para obtener tu cotización y poder
                  matricularte con nosotros en:
                </h1>

                <div
                  v-if="isEsencial(selectedProgram.name)"
                  class="plan-selected-title"
                  :class="{
                    'plan-selected-title-red':
                      selectedProgram.name === 'Tradicional PSU 4° Medio',
                    'plan-selected-title-purple':
                      selectedProgram.name === 'Academia PSU Egresados',
                  }"
                >
                  <div class="border-ecesnsial">
                    <div class="border1"></div>
                    <div class="border2"></div>
                  </div>
                  <div class="d-flex flex-col ml-2">
                    <span>PROGRAMA</span>
                    <h2>{{ programSelectedTitle }}</h2>
                  </div>
                </div>

                <div
                  v-else
                  :style="{
                    borderLeft:
                      '8px solid ' + getBorderTop(selectedProgram.name),
                  }"
                  class="plan-selected-title"
                  :class="{
                    'plan-selected-title-red':
                      selectedProgram.name === 'Tradicional PSU 4° Medio',
                    'plan-selected-title-purple':
                      selectedProgram.name === 'Academia PSU Egresados',
                  }"
                >
                  <span>PROGRAMA</span>
                  <h2>{{ programSelectedTitle }}</h2>
                </div>
              </div>

              <div class="banner-home-green-content only-mobile">
                <p>Sólo matriculando online obtén hasta un</p>
                <h2>50% de descuento</h2>
                <!-- <h2>{{ discount }}% descuento</h2> -->
              </div>

              <div class="relative">
                <img
                  src="/images/featured/puntos-mobile-up.svg"
                  class="only-mobile puntos-mobile-up"
                  alt="puntos-up"
                />
                <div class="card-blanca relative">
                  <form
                    id="programInscription"
                    @submit.prevent="ifFormValid($event, submit)"
                    class="programInscription"
                  >
                    <div class="form-group flex flex-col">
                      <label for="inscriptionName">Nombre del Estudiante</label>
                      <input
                        v-model="formStudent.name"
                        type="text"
                        id="inscriptionName"
                        name="nombre"
                        onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                        maxlength="30"
                      />
                    </div>

                    <div class="form-group flex flex-col">
                      <label for="apellido-paterno">Primer apellido</label>
                      <input
                        type="text"
                        v-model="formStudent.fatherLastName"
                        id="apellido-paterno"
                        name="apellidoPaterno"
                        onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                        maxlength="12"
                      />
                    </div>

                    <div class="form-group flex flex-col">
                      <label for="apellido-paterno">Segundo apellido</label>
                      <input
                        type="text"
                        v-model="formStudent.lastName"
                        id="segundo-apellido"
                        name="lastName"
                        onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                        maxlength="12"
                      />
                    </div>
                    <div class="form-group flex flex-col">
                      <label for="fecha-nacimiento">Fecha de nacimiento</label>
                      <vue-mask
                                            placeholder="dd/mm/aaaa"
                                            mask="DA/MO/YEXR"
                                            :raw="false"
                                            v-model="
                                              formStudent.birthday
                                            "
                                            :options="dateMaskOptions"
                                            name="fecha"
                                          ></vue-mask>
                    </div>

                    <div class="form-group flex flex-col">
                      <label for="">RUT</label>
                      <vue-mask
                        mask="00.000.000-K"
                        :raw="false"
                        v-model="formStudent.rut"
                        :options="{
                          reverse: true,
                          translation: { K: { pattern: /[0-9kK]/ } },
                        }"
                        id="rut"
                        name="rut"
                      ></vue-mask>
                    </div>

                    <div class="form-group flex flex-col">
                      <label for="">Mail</label>
                      <input
                        type="email"
                        v-model="formStudent.email"
                        id="email"
                        name="email"
                        maxlength="50"
                      />
                    </div>

                    <div class="form-group flex flex-col" v-if="showPreferredVenue">
                      <label for="sede">Sede de preferencia</label>
                      <multiselect
                        v-model="formStudent.preferredVenue"
                        :options="[...venueOptions]"
                        id="sede"
                        name="sede"
                        placeholder="Seleccionar sede de preferencia"
                        track-by="id"
                        label="name"
                        :showLabels="false"
                        class="multiselect-custom"
                      />

                      <input
                        type="hidden"
                        name="sede"
                        :value="
                          preferredVenue ? formStudent.preferredVenue.name : ''
                        "
                      />
                      <input
                        type="hidden"
                        name="sede"
                        :value="preferredVenue ? preferredVenue.name : ''"
                        data-rule-required="true"
                        data-msg-required="Debes seleccionar una sede"
                      />
                    </div>
                    <div class="form-group">
                      <button
                        type="submit"
                        class="boton-new-primario boton-new-mediano w-full"
                      >
                        COTIZA Y MATRICÚLATE
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="columna-textura">
              <div class="banner-home-green-content only-mobile">
                <p>Sólo matriculando online obtén hasta un</p>
                <h2>50% de descuento</h2>

              </div>
              <div class="banner-home-green-content only-desktop">
                <p>Sólo matriculando online obtén hasta un</p>
                <h2>50% de descuento</h2>

              </div>

              <img
                src="/images/featured/astronauta.svg"
                class="astronauta-img"
                alt="astronauta-img"
              />
            </div>
          </div>
        </div>
      </div>

      <img
        src="/images/featured/puntos-mobile.svg"
        class="only-mobile puntos-desktop"
        alt="puntos"
      />
      <img
        src="/images/featured/puntos-morados-desktop.svg"
        class="only-desktop puntos-desktop"
        alt="puntos"
      />
    </div>

    <div v-if="showModal" class="modal-intensive" id="modalIntensive">
      <div class="content realtive">
        <div class="text-content">
          <div class="d-flex justify-content-center mb-4">
            <img
              src="/images/featured/IconButtonRelod.svg"
              alt="IconButtonRelod"
            />
          </div>
          <h5>Espera un momento mientras procesamos tu solicitud</h5>
          <p>Esto puede demorar unos segundos.</p>
        </div>
      </div>
    </div>
  </layout-default>
</template>

<script>
import LayoutDefault from "@/layouts/Default";
import Multiselect from "vue-multiselect";
import formValidation from "@/mixins/formValidation";
import recaptchaVisibility from "@/mixins/recaptchaVisibility";
import vueMask from "vue-jquery-mask";
import Cookies from "js-cookie";


export default {
  data() {
    return {
      bgColorRed: true,
      discount: null,
      showModal: false,
      // Aquí se define el objeto que contendrá la información del estudiante:
      formStudent: {
        name: null,
        fatherLastName: null,
        lastName: null,
        rut: null,
        email: null,
        preferredVenue: "-", 
        birthday: null,


      },
      dateMaskOptions: {
        // These are the initial regex
        translation: {
          D: { pattern: /[0-3]/ },
          A: { pattern: /[0-9]/ },
          M: { pattern: /[0-1]/ },
          O: { pattern: /[0-9]/ },
          Y: { pattern: /[1-2]/ },
          E: { pattern: /[90]/ },
          X: { pattern: /[0-9]/ },
          R: { pattern: /[0-9]/ },
        },

        onKeyPress: function (cep, event, currentField, options) {
          if (!cep) return;
          let m = cep.match(/(\d{1})/g);
          if (!m) return;

          if (parseInt(m[0]) === 3) {
            options.translation.A.pattern = /[0-1]/;
          } else if (parseInt(m[0]) === 0) {
            options.translation.A.pattern = /[1-9]/;
          } else {
            options.translation.A.pattern = /[0-9]/;
          }

          if (parseInt(m[2]) === 1) {
            options.translation.O.pattern = /[0-2]/;
          } else {
            options.translation.O.pattern = /[1-9]/;
          }

          if (parseInt(m[4]) === 2) {
            options.translation.E.pattern = /[0]/;
          } else {
            options.translation.E.pattern = /[9]/;
          }

          if (parseInt(m[5]) === 0) {
            options.translation.X.pattern = /[0-9]/;
          } else {
            options.translation.X.pattern = /[0-9]/;
          }

          if (parseInt(m[6]) === 0 && parseInt(m[5]) === 0) {
            options.translation.R.pattern = /[0-9]/;
          } else {
            options.translation.R.pattern = /[0-9]/;
          }

          let temp_value = currentField.val();
          currentField.val("");
          currentField.unmask().mask("DA/MO/YEXR", options);
          currentField.val(temp_value);
        },
      },
      // Opciones para el select:
      venueOptions: [],
    };
  },
  computed: {
    formStudent() {
      //formatear fecha de nacimiento a dd-mm-yyyy
      const birthday = this.$store.getters.lastStudent.birthday;
      const day = birthday.getDate();
      const month = birthday.getMonth() + 1;
      const year = birthday.getFullYear();
      const formattedBirthday = `${day}-${month}-${year}`;
      return {
        name: this.$store.getters.lastStudent.name || null,
        fatherLastName: this.$store.getters.lastStudent.fatherLastName || null,
        lastName: this.$store.getters.lastStudent.lastName || null,
        rut: this.$store.getters.lastStudent.rut || null,
        email: this.$store.getters.lastStudent.email || null,
        preferredVenue: this.$store.getters.lastStudent.preferredVenue || null,
        birthday: formattedBirthday|| null,
      };
    },
    lastStudent() {
      return this.$store.getters.lastStudent;
    },
    preferredVenue() {
      return this.formStudent.preferredVenue;
    },
    showPreferredVenue() {
      if (this.selectedProgram && this.selectedProgram.name) {
        const programName = this.selectedProgram.name.trim().toLowerCase();
        return !programName.includes("pdvx");
      }
      return true;
    },
    selectedProgram() {
      return this.$store.state.selectedProgram;
    },
    students() {
      return this.$store.state.students;
    },
    programSelectedTitle() {
      return this.$store.state.selectedProgram.name;
    },
    selectedProgram() {
      return this.$store.state.selectedProgram ;
    },
    getFormatProgramName() {
      const data = this.$store.state.formatProgramName;
      if (data.nivel3 != "") {
        return data.nivel1 + " > " + data.nivel2 + " > " + data.nivel3;
      }
      return data.nivel1 + " > " + data.nivel2;
    },
  },
  components: {
    LayoutDefault,
    vueMask,
    Multiselect,
  },
  mixins: [formValidation, recaptchaVisibility],

  watch: {
    preferredVenue(newValue) {
      this.$nextTick(() => {
        const hiddenInput = document.getElementsByName("sede")[0];
        if (hiddenInput) {
          hiddenInput.dispatchEvent(new Event("change"));
        }
      });
    },
  },
  methods: {
    getAllLocations() {
      this.Axios.get("/locations?justIdNameAndCommuneId=true").then(
        (response) => {
          this.venueOptions = response.data;
        }
      );
    },
    getBorderTop(f) {
      let e;
      const data = this.$store.state.formatProgramName;
      if (!data || data.nivel2 == "") {
        return "";
      } else {
        e = data.nivel2.toLowerCase();
        if (e.includes("tradicional")) {
          return "#AE4239";
        } else if (e.includes("pdvx")) {
          return "#FFD100";
        } else if (e.includes("pdv online") || e.includes("online")) {
          return "#592466";
        } else if (e.includes("mentoring") || e.includes("esencial")) {
          return "#5E9C3D";
        } else {
          return "#b6b6b6";
        }
      }
    },
    isEsencial(e) {
      if (!e) {
        return false;
      }
      e = e.toLowerCase();
      return e.includes("mentoring") || e.includes("esencial");
    },
    async submit() {
      this.showModal = true;
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha("registerStudent");
      if (token) {
        const result = await this.Axios.post("/verify-recaptcha", {
          recaptchaToken: token,
        });
        if (result.data.success) {
          this.saveFormInfo();
        }
      }
    },
    async saveFormInfo() {
      const res = await this.createStudent();
      await this.$store.dispatch("addStudent", {
        ...res.data,
        fatherLastName: this.formStudent.fatherLastName,
        preferredVenue: this.formStudent.preferredVenue,
      });
      let sessionState = {
        students: this.students,
      };
      await this.$store.dispatch("addInfoToFullOrder", {
        sessionState: JSON.stringify(sessionState),
      });
      const { data: order } = await this.Axios.post("/orders", {
        ...this.$store.state.fullOrder,
        initialStudentId: this.students[0].id,
      });
      Cookies.set("sessionId", order.sessionId);
      Cookies.set("orderId", order.id);

      localStorage.ordenID = order.id;

      this.showModal = false;
      this.goToNextStep();
    },

    goToNextStep() {
      this.$router.push({ name: "Step1" });
    },

    createStudent() {
      return new Promise((resolve, reject) => {
        const studentData = {
          ...this.formStudent,
          sede: this.formStudent.preferredVenue,
        };

        this.Axios.post("/students", studentData)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            if (error.response.status === 400) {
              if (
                error.response.data.message ===
                "Error - Email address already in use!"
              ) {
                alert(
                  "El correo: " +
                    error.response.data.problemField.email +
                    " ya se encuentra registrado"
                );
              }
            }
            reject(error);
          });
      });
    },
  },

  created() {
    if (localStorage.getItem("fullOrder")) {
      localStorage.removeItem("fullOrder");
      this.$router.push("/");
    }
    this.Axios.get("/dashadmin/infogeneral").then((response) => {
      this.discount = response.data[0].discount;
    });
    this.getAllLocations();
  },
  mounted() {
    if (localStorage.getItem("fullOrder")) {
      localStorage.removeItem("fullOrder");
      this.$router.push("/");
    }
    this.validateForm(
      $("#programInscription"),
      {
        nombre: {
          required: true,
          lettersonly: true,
        },

        apellidoPaterno: {
          required: true,
          lettersonly: true,
        },

        apellidoMaterno: {
          required: true,
          lettersonly: true,
        },

        fechaNacimiento: {
          required: true,
          date: true,
        },

        rut: {
          required: true,
          rut: true,
        },

        email: {
          minlength: true,
          required: true,
          email: function (value) {
            //return /^([a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)@[a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)\.[a-zA-Z]{2,7})$/.test(
            return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(
              value
            );
          },
        },
      },

      {
        apellidoPaterno: {
          required: "Debes ingresar tu apellido paterno",
          lettersonly: "Solo se permiten letras",
        },

        apellidoMaterno: {
          required: "Debes ingresar tu apellido materno",
          lettersonly: "Solo se permiten letras",
        },

        nombre: {
          required: "Ingresa tu nombre",
          lettersonly: "Solo se permiten letras",
        },

        rut: {
          required: "Debes ingresar el RUT",
          rut: "El RUT ingresado no es válido",
        },

        fechaNacimiento: {
          required: "Debes ingresar tu fecha de nacimiento",
          date: "Debes ingresar una fecha válida",
        },

        email: {
          minlength: "Debes ingresar un correo valido",
          required: "Debes ingresar un correo",
          email: "Debes ingresar un correo valido",
        },
      },
      {
        ignore: "",
      }
    );
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.border-ecesnsial {
  margin-right: 8px;
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;

  @media (max-width: 768px) {
    width: 8px;
  }
  @media (min-width: 769px) {
    width: 8px;
  }

  .border1 {
    flex: 1;
    background: #ae4239;
  }
  .border2 {
    flex: 1;
    background: #ffd100;
  }
}

.boton-new-primario {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: $morado50;
  border: solid 4px $neutralwhite;
  color: $neutralwhite;
  &:hover {
    background-color: $morado30;
  }
  &:active {
    background-color: $morado90;
  }
  &:focus {
    background-color: $morado50;
    border: solid 4px grey;
  }
  &:disabled {
    background-color: #5924661a;
  }

  &.boton-new-largo {
    padding: 0 32px;
    height: 60px;
    width: auto;
    font-size: 20px;
    line-height: 28px;
  }
  &.boton-new-mediano {
    padding: 0 24px;
    height: 48px;
    width: auto;
    font-size: 16px;
    line-height: 18px;
  }
  &.boton-new-pequeno {
    padding: 0 16px;
    height: 32px;
    width: auto;
    font-size: 14px;
    line-height: 22px;
  }
}

.banner-home-green-content {
  background-color: $verdeOscuro;
  padding: 15px 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  z-index: 10;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
  }
  @media (min-width: 769px) {
    width: auto;
    text-align: start;
  }

  .gree-arrow {
    position: absolute;
    width: 30px;
    height: 37px;
    left: -17px;
    bottom: -22px;
  }

  p {
    color: #fff;
    margin-bottom: 10px;
    font-size: 20px;
    line-height: 28px;
    font-family: "Poppins-Medium", sans-serif;
  }

  h2 {
    color: #fff;
    font-size: 40px;
    line-height: 50px;
    font-family: "Poppins-Bold", sans-serif;
    margin-bottom: 0;

    @media (max-width: 769px) {
      font-size: 28px;
      line-height: 36px;
    }
  }
}

.formulario-inscribir {
  .form-group {
    margin-bottom: 0.8rem;
  }

  width: 100%;
  /*background-color: $amarrillo50;*/
  background-color: #fff;

  .contenido-formulario {
    @media (max-width: 768px) {
      margin: 0 24px;
      padding-top: 24px;
      padding-bottom: 32px;
    }
    @media (min-width: 769px) {
      margin: 0 126px;
      padding-top: 40px;
      padding-bottom: 56px;
    }
  }

  .contenido-formulario {
    display: flex;
    flex-direction: column;

    .contenido-formulario-titulo {
      /*@media (max-width: 768px) {
        display: none;
      }*/
      margin-bottom: 25px;
      h1 {
        font-family: "Poppins-Bold", sans-serif;
        font-size: 22px;
        line-height: 32px;
        color: $colorTerciario !important;
        margin-bottom: 24px;
      }
    }
    .contenido-formulario-form {
      display: flex;
      @media (max-width: 768px) {
        flex-direction: column;
      }
      @media (min-width: 769px) {
        flex-direction: row;
      }

      .columna-form {
        @media (max-width: 768px) {
          width: 100%;
        }
        @media (min-width: 769px) {
          padding-right: 50px;
          width: 55%;
        }

        .card-blanca {
          border-radius: 8px;
          border: 2px solid $neutralBlack;
          background: $neutralwhite;
          border-radius: 8px;
          padding: 24px;
          display: flex;
          flex-direction: column;
          position: relative;
          z-index: 10;
          @media (max-width: 768px) {
            margin-top: 28px;
          }
          @media (min-width: 769px) {
            margin-top: 32px;
          }

          .programInscription {
            display: flex;
            flex-direction: column;

            .form-group {
              label {
                font-family: "Poppins-Medium", sans-serif;
                font-size: 14px;
                line-height: 22px;
              }
              input {
                height: 48px;
                border-radius: 100px;
                border: solid 2px $neutral30;
                padding: 12px 24px 12px 24px;
              }
            }
          }
        }
      }
      .columna-textura {
        width: 45%;

        @media (max-width: 768px) {
          display: none;
        }
        .astronauta-img {
          padding-left: 100px;
          width: 100%;
          height: auto;
          @media (max-width: 768px) {
            display: none;
          }
        }
      }
    }
  }
}

.puntos-desktop {
  position: absolute;
  left: 0;
  bottom: 0;
}

.puntos-mobile {
  position: absolute;
  left: 0;
  bottom: 0;
}

.puntos-mobile-up {
  position: absolute;
  top: -30px;
  right: -16px;
}

.tradicional-4-medio-inscription {
  padding-top: 120px;
  position: relative;
  height: 850px;
  background: $yellow;
  @include media-breakpoint-down(sm) {
    height: auto;
    padding-bottom: 110px;
  }

  .logo {
    padding: 10px 34px;
  }

  .main-content {
    img {
      width: 600px;
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .main-content-text {
      p {
        letter-spacing: 4px;
        line-height: 19px;
        margin-bottom: 0;
        @include font-medium-regular;
        color: #000;
        @include media-breakpoint-down(sm) {
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 20px;
        }
      }

      h3 {
        color: #000;
        font-size: 35px;
        line-height: 38px;
        margin-bottom: 0;
        @include font-extra-bold-regular;
        @include media-breakpoint-down(sm) {
          font-size: 25px;
          line-height: 25px;
        }
      }
    }
  }
}

.pdv-submit-button {
  button {
    background: #ffffff;
    box-shadow: none;
  }

  .form-group {
    margin-bottom: 0;
  }

  @include media-breakpoint-down(sm) {
    position: fixed;
    width: 100%;
    padding: 23px 16px;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #000;
  }
}

.modal-intensive {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  z-index: 1000;
  overflow: hidden;
  display: flex;
  align-items: center;
  height: 100vh;
  background: rgba(134, 133, 133, 0.1);

  .content {
    position: relative;
    width: 40%;
    border-radius: 24px;
    border: 2px solid $neutralBlack;
    background: $neutralwhite;
    padding: 24px;
    box-shadow: 0 0 12px 3px #00000038;
    min-height: 380px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include media-breakpoint-down(sm) {
      width: 90%;
    }

    .header {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;

      .btn-modal {
        font-size: 30px;
        border: none;
        background: transparent;
        color: #fff;
        &:hover {
          cursor: pointer;
        }
      }
    }

    .text-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      padding: 0 70px;

      h5 {
        color: $neutralBlack;
        text-align: center;
        font-family: "Poppins-Bold", sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
        margin-bottom: 10px;
      }

      p {
        color: $neutral80;
        text-align: center;
        font-family: "Poppins-Regular", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 0px;

        span {
          font-family: "Poppins-Bold", sans-serif;
          font-weight: 700;
        }
      }
    }
  }
}

.img-modal-loading {
  position: absolute;
  right: 20px;
  bottom: 20px;
  height: 70%;

  @media (max-width: 768px) {
    display: none;
  }
}

.plan-selected-title {
  padding-left: 8px;
  position: relative;
  span {
    font-family: "Poppins-Regular", sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: $neutral70;
  }
  h2 {
    font-family: "Poppins-Bold", sans-serif;
    font-size: 22;
    line-height: 35px;
    margin-bottom: 0;
    /*text-transform: uppercase;*/
    color: $neutralBlack;
    @media screen and (max-width: 768px) {
      font-size: 22px;
      line-height: 37px;
    }
    @media screen and (min-width: 769px) {
    }
  }
  &.plan-selected-title-red {
    span {
      background: $red-light;
    }

    h2 {
      color: $red-2-light;
    }
  }

  &.plan-selected-title-purple {
    span {
      background: $purple-light;
    }

    h2 {
      color: $purple;
    }
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
